var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9614 8.51205L14.1574 9.91605C13.6774 9.59205 13.1614 9.34005 12.6694 9.20805V11.0321C14.4934 11.5241 15.2734 12.2561 15.2734 13.6001V13.6241C15.2734 14.9681 14.2414 15.8321 12.7294 15.9881V17.1761H11.4814V15.9641C10.4494 15.8321 9.44141 15.4241 8.64941 14.8241L9.58541 13.4561C10.2334 13.9481 10.8334 14.2841 11.5414 14.4281V12.5201C9.81341 12.0521 8.96141 11.4041 8.96141 9.97605V9.95205C8.96141 8.63205 9.96941 7.75605 11.4814 7.60005V6.90405H12.7294V7.63605C13.5814 7.74405 14.3014 8.05605 14.9614 8.51205ZM13.5214 13.6961C13.5214 13.3001 13.3174 13.0481 12.6694 12.8081V14.4881C13.2334 14.4041 13.5214 14.1521 13.5214 13.7201V13.6961ZM10.7134 9.86805C10.7134 10.2521 10.8814 10.4921 11.5414 10.7321V9.10005C10.9534 9.17205 10.7134 9.46005 10.7134 9.84405V9.86805Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.092a1a667ab6f2530c9f4a7d3bdf42a3.svg";
export { ForwardRef as ReactComponent };